// @flow
import React from "react";
import type { Game, TicketReservationStatusType } from "../../common/types";
import {
  SuspenseWithPerf,
  useAuth,
  useFirestore,
  useFirestoreDocData,
} from "reactfire";
import GameDetailsFooterReserve from "./GameDetailsFooterReserve";
import GameDetailsFooterTicket from "./GameDetailsFooterTicket";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import ListItem from "@material-ui/core/ListItem";
import Skeleton from "@material-ui/lab/Skeleton";

type Props = {
  game: Game,
  ticketReservationStatus: TicketReservationStatusType,
};

function GameDetailsFooterTicketOrReserve(props: Props) {
  const auth = useAuth();
  const firestore = useFirestore();
  const user = auth.currentUser;

  const { game } = props;

  const userDataRef = firestore.collection("users").doc(user.uid);
  const userData = useFirestoreDocData(userDataRef);

  const hasTicket = userData.gameIdsWithTicketReservations != null && userData.gameIdsWithTicketReservations.includes(game.id);

  if (!hasTicket) {
    return <GameDetailsFooterReserve {...props} />;
  }

  return (
    <SuspenseWithPerf
      traceId="GameDetailsFooterTicket"
      fallback={
        <ListItem>
          <Box mt={1} style={{ width: "100%", textAlign: "center" }} mb={2}>
            <Button disabled variant="outlined" color="primary" size="large">
              <Skeleton />
            </Button>
          </Box>
        </ListItem>
      }
    >
      <GameDetailsFooterTicket gameId={game.id} userId={user.uid} />
    </SuspenseWithPerf>
  );
}

export default GameDetailsFooterTicketOrReserve;
